// extracted by mini-css-extract-plugin
module.exports = {"name":"section-name-box-m__name__2dA5b"};